module.exports = __webpack_public_path__ + "static/media/apps.1f10f0e0.svg";